import { apiFetch } from "@/lib/api-client";

export interface Invite {
  id: number;
  code: string;
  company_id: number;
  created_by: number | null;
  max_uses: number | null;
  used: number;
  expires_at: string | null;
  revoked: number | boolean;
  note: string | null;
  created_at: string;
  status: "active" | "revoked" | "expired" | "exhausted";
  invite_url: string;
}

export interface CreateInvitePayload {
  /** null = 不限次数 */
  max_uses?: number | null;
  /** 0 / null = 永不过期; 默认 168 (7 天) */
  expires_in_hours?: number | null;
  note?: string;
}

export async function listInvites() {
  return apiFetch<{ success: boolean; data: Invite[] }>("/api/company/invites");
}

export async function createInvite(p: CreateInvitePayload) {
  return apiFetch<{ success: boolean; data: Invite }>("/api/company/invites", {
    method: "POST",
    body: JSON.stringify(p),
  });
}

export async function revokeInvite(id: number) {
  return apiFetch<{ success: boolean }>(`/api/company/invites/${id}`, { method: "DELETE" });
}

export async function emailInvite(code: string, email: string) {
  return apiFetch<{ success: boolean }>(
    `/api/company/invites/${encodeURIComponent(code)}/email`,
    { method: "POST", body: JSON.stringify({ email }) },
  );
}
